import React, { Component } from 'react';

export default class FormatCurrency extends Component {
    render() {
        return (
            <span>
                {(this.props.amount || this.props.amount === 0) ? 
                    new Intl.NumberFormat('en', { 
                        style: 'currency', 
                        currency: 'USD' 
                    }).format(this.props.amount)
                : null}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/FormatCurrency/index.js